<template>
  <div class="header">
    <div class="header-container">
      <div class="header-container__nav">
        <div class="header-container__nav--left">
          <img
            id="menu-img"
            class="clickable"
            src="@/assets/icons/menu.svg"
            @click="sideNavOpen = !sideNavOpen"
          />

          <nav class="for-large-width">
            <router-link :to="{ name: 'Home' }">Home</router-link>
            <router-link :to="{ name: 'About' }">About us</router-link>
            <router-link :to="{ name: 'Contacts' }">Contact us</router-link>
            <router-link :to="{ name: 'ListEngagements' }">Our Engagements</router-link>
          </nav>
        </div>

        <div class="header-container__nav--right">
          <router-link :to="{ name: 'SearchProjects' }">
            <font-awesome-icon icon="search" size="2x" class="icon" />
          </router-link>
          <div v-if="userIsLoggedIn" @click="notificationsOpen = !notificationsOpen">
            <font-awesome-icon icon="bell" size="2x" class="icon clickable" />
            <span :class="{ unread: unreadNotificationCount }"></span>
          </div>
          <a href="https://api.whatsapp.com/send?phone=254722263722" target="_blank">
            <font-awesome-icon :icon="['fab', 'whatsapp']" size="2x" class="icon" />
          </a>
        </div>
      </div>
    </div>

    <SideNavigation v-if="sideNavOpen" />
    <NotificationsDropdown v-if="notificationsOpen" @close="notificationsOpen = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SideNavigation from '@/components/SideNavigation'
import NotificationsDropdown from '@/components/NotificationsDropdown'

export default {
  name: 'Header',
  components: { SideNavigation, NotificationsDropdown },
  data() {
    return {
      searchText: 'Search',
      projectText: 'Projects',
      Goals: 'Goals',
      menuText: 'Change Feed',
      responsive_enabled: false,
      sideNavOpen: false,
      notificationsOpen: false,
      isHomeLogo: true,
    }
  },
  computed: {
    ...mapGetters(['userIsLoggedIn', 'unreadNotificationCount']),
  },
  created() {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        this.responsive_enabled = false
      }
    }),
      //closes side nav dropdown when clicked outside of icon
      window.addEventListener('click', () => {
        const menuIconElement = document.querySelector('#menu-img')
        if (menuIconElement !== event.target && this.sideNavOpen) {
          this.sideNavOpen = false
        }
      }),
      // closes notifications dropdown when clicked outside of icon
      window.addEventListener('click', e => {
        if (!this.$el.contains(e.target) && this.notificationsOpen) {
          this.notificationsOpen = false
        }
      })
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/variables';
@import '../styles/mixins/labels';

.header-container {
  display: flex;
  flex-direction: row;
  font-family: $base-font-family;
  background-color: $primary;
  width: auto;
  align-items: center;
  padding: 2rem 1rem;

  &__nav {
    display: flex;
    flex-direction: row;
    height: inherit;
    align-items: center;
    width: 100vw;

    @media (max-width: 768px) {
      &__icon {
        display: inline-flex;
        margin-right: 5vw;
      }
    }

    &--left {
      @include label();
      background-color: transparent;
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-grow: 1;
    }

    &--right {
      display: flex;
      flex-direction: row-reverse; /* placement of icons start from right-hand side*/
      flex-grow: 1;
      justify-content: flex-start;

      .icon {
        color: white;
      }

      & > *:not(:first-child) {
        margin-right: 1.5rem;
      }
    }
  }
}

nav {
  display: flex;
  align-items: center;
  margin-left: 1.3rem;

  a {
    padding: 0.3rem 1rem;
    font-weight: 900;
    color: white;
  }
}

.for-large-width {
  @media screen and (max-width: 899px) {
    display: none;
  }
}

.unread {
  position: absolute;
  color: white;
  right: 4rem;
  height: 1rem;
  width: 1rem;
  background-color: rgb(100, 167, 91);
  border-radius: 50%;
}

.clickable {
  cursor: pointer;
}

#menu-img {
  max-width: 2rem;
}
</style>
